import FJMessageStore from '../../../store/FJMessageStore.js';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJTextBasedEditingMedia from '../../../core/textBasedEditing/FJTextBasedEditingMedia.jsx';
import {
    setActivePanelName,
    setCurrentMatchIndex,
    setHistoryData,
    setIsLoadingResourceAction,
    setMatchIndexList,
    setOriginalResourceDataAction,
    setSearchTextAction,
} from '../../slices/FJTextBasedEditing.jsx';
import { setSliceIsDoneAction, setSliceTaskStatusAction } from '../../slices/FJSliceCommon.js';
import FJConstant from '../../../constants/FJConstant.js';
import FJUtil from '../../../util/FJUtil.js';
import FJActionCommon from '../FJActionCommon.js';
import FJActionModal from '../FJActionModal.js';
import FJTextBasedEditingConfig from '../../../config/appConfig/FJTextBasedEditingConfig.js';
import FJConfig from '../../../config/FJConfig.js';
import FJImageStore from '../../../store/FJImageStore.js';
import FJS3Config from '../../../config/FJS3Config.js';
import FJNetworkStore from '../../../store/FJNetworkStore.js';
import FJActionRightTextBaseEditing from './FJActionRightTextBaseEditing.js';
import { MAX_POLLING_ERROR_TIME, TASK_POLLING_INTERVAL } from '../../../config/dataConfig/FJGenerateData.js';
import FJTextContent from '../../../core/textBasedEditing/FJTextContent.js';
import FJTextEditStore from '../../../store/FJTextBaseEditing/FJTextEditStore.js';
import { setEditFloatingPanelVisible } from '../../slices/FJSliceTextEditFloatingPanel.js';

import FJActionTextBasedEditingExtension from './FJActionTextBasedEditingExtension.js';
import { setSliceLoadingModalData } from '../../slices/FJSliceModals.js';

let f_eventId = null;

const _pollingTask = (eventId, callback) => {
    let timer = null;
    let errorTime = 0;
    let isStopPolling = false;

    const __cancelTimer = () => {
        clearTimeout(timer);
        timer = null;
    };

    const __request = async () => {
        try {
            const result = await FJNetworkStore.getTaskState(eventId);
            if (!result) {
                errorTime++;
                if (errorTime >= MAX_POLLING_ERROR_TIME) {
                    throw new Error('failed');
                } else {
                    timer = setTimeout(__request, 1000);
                }
                return;
            }

            const jobState = result.job_state;
            if (jobState === 'succeeded') {
                if (result?.out_put[0]) {
                    const outPutData = result?.out_put[0];
                    callback && callback({ type: FJConstant.SUCCESS, data: outPutData });
                } else {
                    throw new Error('failed');
                }
                isStopPolling = true;
            } else if (jobState === 'canceled') {
                isStopPolling = true;
                callback && callback({ type: FJConstant.CANCEL });
            } else if (jobState === 'failed') {
                throw new Error('failed');
            }

            if (isStopPolling || eventId !== f_eventId) {
                __cancelTimer();
            } else {
                timer = setTimeout(__request, TASK_POLLING_INTERVAL);
            }
        } catch (e) {
            console.log(e);
            __cancelTimer();
            callback && callback({ type: FJConstant.ERROR });
        }
    };
    timer = setTimeout(__request, TASK_POLLING_INTERVAL);
};

const _updateRightView = () => {
    return dispatch => {
        // TODO 右侧界面
        dispatch(FJActionRightTextBaseEditing.pauseAction());
        dispatch(FJActionRightTextBaseEditing.updateHasUndoRedoAction());
        dispatch(FJActionRightTextBaseEditing.updateSplitTimeListAction());
    };
};

const _getDurationRange = duration => {
    const a = [
        { max: 5, rang: '0-5' },
        { max: 10, rang: '5-10' },
        { max: 15, rang: '10-15' },
        { max: 20, rang: '15-20' },
        { max: 25, rang: '20-25' },
        { max: 30, rang: '25-30' },
        { max: 35, rang: '30-35' },
    ];
    let d = '';
    for (let i = 0; i < a.length; i++) {
        const { max, rang } = a[i];
        if (max * 60 >= duration) {
            d = rang;
            break;
        }
    }
    if (!d) d = '35-40';
    return d;
};

const FJActionTextBasedEditing = {
    uploadFileAction: file => {
        return async (dispatch, getState) => {
            if (!file || getState().textBasedEditing.isLoadingResource) return;

            dispatch(FJActionRightTextBaseEditing.pauseAction());
            dispatch(setIsLoadingResourceAction(true));

            const newMedia = new FJTextBasedEditingMedia();
            newMedia.setMediaSource(file);
            newMedia
                .loadMediaSource()
                .then(() => {
                    FJTextEditStore.setMedia(newMedia);
                    const { type, mediaId: id, url, duration } = newMedia;
                    dispatch(FJActionRightTextBaseEditing.initRightTextBaseEditingAction(url, type));
                    dispatch(setOriginalResourceDataAction({ type, id, url, duration }));
                    dispatch(setHistoryData(null));
                })
                .catch(e => {
                    newMedia.release();
                    switch (e.message) {
                        case 'unsupported format':
                            FJMessageStore.addMessage(
                                FJLocalStore._('unsupported-format-please-upload-a-video-audio'),
                                'error',
                            );
                            break;
                        case 'load media source failed':
                        case 'decode audio error':
                            FJMessageStore.addMessage(FJLocalStore._('analysis-failed-please-try-again'), 'error');
                            break;
                        case 'file too large':
                            FJMessageStore.addMessage(FJLocalStore._('upload-file-too-big'), 'error');
                            break;
                        case 'duration error': {
                            FJUtil.eaLog('text based editing duration error show');
                            FJMessageStore.addMessage(
                                FJLocalStore._('please-upload-a-video-audio-that-is-between-1s-and-40min'),
                                'error',
                            );
                            break;
                        }

                        default:
                            console.log(e.message);
                            break;
                    }
                })
                .finally(() => {
                    dispatch(setIsLoadingResourceAction(false));
                });
        };
    },

    onGenerateAction: () => {
        return (dispatch, getState) => {
            (async () => {
                dispatch(FJActionRightTextBaseEditing.pauseAction());
                const { creditNumber, freeNumCreation, appType } = getState().common;
                const { selectedLanguage } = getState().textBasedEditing;

                const media = FJTextEditStore.getMedia();
                if (!media) {
                    FJMessageStore.addMessage(FJLocalStore._('please-upload-a-video-audio-first'), 'error');
                    return;
                }

                const { audioResource, duration, mediaId, type } = media;
                if (!audioResource) {
                    FJMessageStore.addMessage(FJLocalStore._('please-upload-a-video-audio-first'), 'error');
                    return;
                }

                if (getState().textBasedEditing.isLoadingResource) return;

                // 开启加载UI
                dispatch(setSliceTaskStatusAction(FJConstant.START));
                dispatch(setSliceIsDoneAction(false));

                const __success = () => {
                    dispatch(setActivePanelName('edit'));
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    dispatch(setSliceIsDoneAction(true));

                    FJUtil.eaLog('text based editing transcribe sucess', {
                        duration: _getDurationRange(duration),
                        type: type,
                        language: selectedLanguage,
                    });
                };

                const __error = () => {
                    dispatch(setActivePanelName('default'));
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                };

                // 登录判断
                const userSpaceType = await FJUtil.checkUserSpace();
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    __error();
                    return;
                }

                // 计算费用
                const usedCredit = Math.ceil(duration / 60) * FJTextBasedEditingConfig.unitPrice;
                const isFree = creditNumber < usedCredit && freeNumCreation;

                //4.额度判断
                if (creditNumber < usedCredit && !freeNumCreation) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    __error();
                    return;
                }

                // 正在转录的进度UI
                dispatch(setActivePanelName('transcribing'));

                const __checkBeCancel = () => {
                    return getState().common.taskStatus === FJConstant.DEFAULT;
                };

                try {
                    // 上传音频数据到s3
                    const key = FJConfig.originalImageKey + `${mediaId}.mp3`;
                    await FJImageStore.upLoadFileToS3Async(audioResource, key);
                    if (__checkBeCancel()) {
                        return;
                    }
                    const s3Url = FJS3Config.S3_SERVER_HOST + key;
                    // 调用API获取文字信息
                    //6.创建任务
                    f_eventId = await FJActionCommon.createRequestTask(async () => {
                        return await FJNetworkStore.audioConvertText(s3Url, selectedLanguage, duration);
                    }, dispatch);
                    // 判断是否取消了任务
                    if (__checkBeCancel()) {
                        return;
                    }

                    FJUtil.eaLog('ai tool start generating', {
                        'credit&free': isFree ? 'free' : 'credit',
                        tool: appType,
                    });

                    // 积分冻结
                    FJUtil.updateAllCreditInfo(isFree);
                    // 轮询任务状态
                    _pollingTask(f_eventId, result => {
                        const { type, data } = result;
                        // cancel和失败时，会进行积分解冻
                        if (type === FJConstant.CANCEL) {
                            FJUtil.updateAllCreditInfo(isFree);
                        } else if (type === FJConstant.ERROR) {
                            FJUtil.updateAllCreditInfo(isFree);
                            __error();
                            FJMessageStore.addMessage(FJLocalStore._('failed-to-transcribe-please-try-again'), 'error');
                        } else if (type === FJConstant.SUCCESS) {
                            FJTextEditStore.loadDataInfo(JSON.parse(data.info), duration, selectedLanguage);
                            __success();
                            FJUtil.eaLog('ai tool generate success', {
                                tool: FJUtil.getToolName(),
                                'credit&free': isFree ? 'free' : 'credit',
                            });
                        }
                    });
                } catch (e) {
                    console.log(e);
                    __error();
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-transcribe-please-try-again'), 'error');
                }
            })();
        };
    },
    onCancelAction: () => {
        return dispatch => {
            (async () => {
                try {
                    f_eventId && (await FJNetworkStore.cancelTask(f_eventId));
                } catch (e) {
                    console.log(e);
                } finally {
                    dispatch(setActivePanelName('default'));
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                }
            })();
        };
    },
    renderAction: () => {
        return (dispatch, getState) => {
            const { isHideTextForDelete, editTextPreviewId } = getState().textBasedEditing;
            const div = document.getElementById(editTextPreviewId);
            if (div) {
                FJTextContent.renderContent(div, isHideTextForDelete);
                FJTextContent.renderStyle();
            }
        };
    },

    //#region 返回和恢复
    goBackAction: () => {
        return (dispatch, getState) => {
            if (getState().textBasedEditing.searchText) dispatch(FJActionTextBasedEditing.onSearchAction(''));
            dispatch(FJActionRightTextBaseEditing.pauseAction());
            dispatch(setActivePanelName('default'));
            FJTextContent.clear();
            FJTextEditStore.clearUndoRedo();
            dispatch(setEditFloatingPanelVisible(false));
            dispatch(setSliceIsDoneAction(false));
            dispatch(FJActionRightTextBaseEditing.restoreTimeLineDataAction());
            dispatch(FJActionRightTextBaseEditing.updateHasUndoRedoAction());
        };
    },
    restoreHistoryAction: () => {
        return (dispatch, getState) => {
            if (getState().textBasedEditing.isLoadingResource) return;

            const data = getState().textBasedEditing.historyData;
            FJTextContent.encode(JSON.parse(data));
            dispatch(FJActionTextBasedEditing.renderAction());
            dispatch(setSliceIsDoneAction(true));
            dispatch(setActivePanelName('edit'));
            dispatch(FJActionRightTextBaseEditing.updateSelectedTimesAction());
            dispatch(FJActionRightTextBaseEditing.updateSplitTimeListAction());
            FJUtil.eaLog('text based editing previous transcript click');
        };
    },
    //#endregion

    //#region 搜索
    onSearchAction: value => {
        return dispatch => {
            dispatch(setSearchTextAction(value));
            const searchValue = value.trim();
            const matchList = FJTextEditStore.matchText(searchValue);
            const indexList = matchList.map(item => FJTextContent.indexOfTextGraph(item));
            dispatch(setCurrentMatchIndex(indexList.length !== 0 ? 0 : -1));
            dispatch(setMatchIndexList(indexList));
            dispatch(setEditFloatingPanelVisible(false));
            dispatch(FJActionRightTextBaseEditing.updateSelectedTimesAction());
            dispatch(FJActionTextBasedEditingExtension.positionTextAction());
            dispatch(FJActionTextBasedEditingExtension.updateFloatingPanelAction());
            dispatch(FJActionTextBasedEditingExtension.seekToSelectedTextAction());
        };
    },
    nextMatchAction: () => {
        return (dispatch, getState) => {
            const { currentMatchIndex, matchIndexList } = getState().textBasedEditing;
            if (matchIndexList.length <= 1) return;
            let nextIndex = currentMatchIndex + 1;
            if (nextIndex >= matchIndexList.length) nextIndex = 0;
            dispatch(setCurrentMatchIndex(nextIndex));
            const textGraphIndex = matchIndexList[nextIndex];
            FJTextEditStore.selectIndex(textGraphIndex);
            dispatch(setEditFloatingPanelVisible(false));
            dispatch(FJActionRightTextBaseEditing.updateSelectedTimesAction());
            dispatch(FJActionTextBasedEditingExtension.positionTextAction());
            dispatch(FJActionTextBasedEditingExtension.updateFloatingPanelAction());
            dispatch(FJActionTextBasedEditingExtension.seekToSelectedTextAction());
        };
    },
    previousMatchAction: () => {
        return (dispatch, getState) => {
            const { currentMatchIndex, matchIndexList } = getState().textBasedEditing;
            if (matchIndexList.length <= 1) return;
            let previousIndex = currentMatchIndex - 1;
            if (previousIndex < 0) previousIndex = matchIndexList.length - 1;
            dispatch(setCurrentMatchIndex(previousIndex));
            const textGraphIndex = matchIndexList[previousIndex];
            FJTextEditStore.selectIndex(textGraphIndex);
            dispatch(setEditFloatingPanelVisible(false));
            dispatch(FJActionRightTextBaseEditing.updateSelectedTimesAction());
            dispatch(FJActionTextBasedEditingExtension.positionTextAction());
            dispatch(FJActionTextBasedEditingExtension.updateFloatingPanelAction());
            dispatch(FJActionTextBasedEditingExtension.seekToSelectedTextAction());
        };
    },
    updateSearchMatchIndexAction: () => {
        return (dispatch, getState) => {
            const { searchText, currentMatchIndex, matchIndexList } = getState().textBasedEditing;
            if (searchText && currentMatchIndex !== -1 && matchIndexList.length !== 0) {
                const selectedList = FJTextContent.getSelectedTextList();
                if (selectedList.length === 1) {
                    const textGraph = selectedList[0];
                    if (textGraph.isMatch) {
                        const index = FJTextContent.indexOfTextGraph(textGraph);
                        const matchIndex = matchIndexList.findIndex(i => i === index);
                        if (matchIndex !== -1) dispatch(setCurrentMatchIndex(matchIndex));
                    }
                }
            }
        };
    },
    //#endregion

    //#region 高光剪辑
    aiClippingContentAction: () => {
        return async (dispatch, getState) => {
            const data = FJTextEditStore.getOriginalDataInfo();
            if (!data) return;
            FJUtil.eaLog('text based editing highlights click');

            if (getState().textBasedEditing.searchText) dispatch(FJActionTextBasedEditing.onSearchAction(''));
            // 登录判断
            const userSpaceType = await FJUtil.checkUserSpace();
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                return;
            }
            // 总额度
            const creditNumber = getState().common.creditNumber;
            const hasFreeCount = getState().textBasedEditing.highLightFreeNum > 0; // 有免费次数
            const isInsufficiency = creditNumber < FJTextBasedEditingConfig.highLightUnitPrice; // 是否积分不足
            const useFree = isInsufficiency && hasFreeCount; // 是否使用免费额度

            //4.额度判断
            if (isInsufficiency && !hasFreeCount) {
                dispatch(FJActionModal.showUpgradeModalAction());
                return;
            }

            dispatch(FJActionTextBasedEditing.onSearchAction(''));
            dispatch(setSliceLoadingModalData({ display: true, message: `${FJLocalStore._('processing')}` }));

            FJNetworkStore.getAIClippingContent(data.text)
                .then(result => {
                    if (!result) {
                        throw Error('data is null');
                    }
                    FJTextEditStore.addUndo();
                    FJTextEditStore.mathAIClippingContent(result);
                    dispatch(FJActionTextBasedEditing.renderAction());

                    dispatch(FJActionRightTextBaseEditing.updateSelectedTimesAction());
                    dispatch(_updateRightView());

                    FJUtil.updateAllCreditInfo(useFree);
                })
                .catch(e => {
                    console.log(e);
                    FJMessageStore.addMessage(
                        FJLocalStore._('failed-to-extract-highlights-please-try-again.'),
                        'error',
                    );
                })
                .finally(() => {
                    dispatch(setSliceLoadingModalData({ display: false }));
                });
        };
    },
    //#endregion
};

export default FJActionTextBasedEditing;
